import { h, Fragment } from "preact";
import sanitizeOptionValue from "../../helpers/sanitizeOptionValue";
import { AccordionCaret } from "../../helpers/icons";

export default function ProductOptionSummary({
  optionName,
  optionNumber,
  selectedOptionValue,
}) {
  return (
    <summary className="product-options__option-summary">
      <div className="product-options__option-summary-content">
        {optionNumber && (
          <div className="product-options__option-number">{optionNumber}.</div>
        )}
        <div className="product-options__name">{optionName}</div>
      </div>
      <div className="product-options__option-summary-status">
        <div className="product-options__selected-value">
          {sanitizeOptionValue(selectedOptionValue)}
        </div>
        <AccordionCaret className="product-options__option-summary-icon" />
      </div>
    </summary>
  );
}
